import React from 'react'
import cx from 'classnames'
import { l, Icon, palettes } from '@manychat/manyui'

import { FieldGroupId } from 'common/fields/entities/enums'
import { Field } from 'common/fields/entities/field'
import { FieldTypeIcons } from 'common/fields/linking/hooks/useFieldsOptions'

export const UserField = ({ field }: { field?: Field }) => {
  const isDeleted = !field

  let IconComponent

  if (isDeleted) {
    IconComponent = Icon.CufNoIcon
  } else {
    IconComponent =
      field.group === FieldGroupId.SYSTEM ? FieldTypeIcons[field.id] : FieldTypeIcons[field.type]
  }

  const caption = isDeleted ? l.translate('Deleted field') : field.caption

  return (
    <p
      className="d-flex align-center gap-xs"
      data-title-at={isDeleted ? 'right' : undefined}
      data-title={
        isDeleted
          ? l.translate(
              'This field has been deleted from settings but still exists in past responses',
            )
          : undefined
      }
    >
      <IconComponent
        size={16}
        color={isDeleted ? palettes.typography.secondary : palettes.typography.body}
      />
      <span className={cx(isDeleted && 'text-disabled', 'text-ellipsis')}>{caption}</span>
    </p>
  )
}
